import { render } from "./VRadioButton.vue?vue&type=template&id=be4a28ae"
import script from "./VRadioButton.vue?vue&type=script&lang=js"
export * from "./VRadioButton.vue?vue&type=script&lang=js"

import "./VRadioButton.vue?vue&type=style&index=0&id=be4a28ae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__